import React from 'react';
import { NotificationBox } from '../../components/Notifications';
import { Paragraph, Title } from '../../components/Text';
import { ActionText } from '../../components/Flex';
import { Modal } from 'antd';
import { CloseIcon } from '../../icons/CloseIcon';
import { UploadDetails } from './UploadDetails';
import { Link } from "react-router-dom";

export const colors = {
    error: "#F25D5D",
    warning: "#E8AF1D",
    info: "#4277CC",
    success: "var(--sp-success-color)"
};

const Notification = ({ notificationId, type, code, message, onClose, log, showLog, visible, onCloseLog, link }) => {
    const color = colors[type];

    return(
        <>
            <NotificationBox color={color} onClose={() => onClose(notificationId)} gap={{ bottom: 4 }}>
                <Title h5 color={color} capitalize>
                    {type} {code}
                </Title>
                <Paragraph>
                    {message}
                </Paragraph>
                {link && <Link to={link.href} onClick={() => onClose(notificationId)}>{link.title}</Link>}
                {Array.isArray(log) && log.length
                    ? <ActionText onClick={() => showLog(notificationId)}>Show details...</ActionText>
                    : null}
            </NotificationBox>
            {visible
            ? <Modal
                centered
                width={600}
                className="sp-modal"
                visible={visible}
                closeIcon={<CloseIcon />}
                footer={<span />}
                onCancel={() => onCloseLog()}
                >
                    <UploadDetails dataSource={log} />
            </Modal>
            : null}
        </>
    )
};

export { Notification };